import { Component, OnInit, Input, ViewChild, Optional, Self, EventEmitter, Output } from '@angular/core';
import * as uuid from 'uuid';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { GeoidAddressModalComponent } from './modal/geoid-address-modal.component';

@Component({
    selector: 'app-form-geoid-address',
    templateUrl: './geoid-address.component.html',
    styleUrls: ['./geoid-address.component.scss'],
})
export class GeoidAddressComponent implements OnInit, ControlValueAccessor {
    public onChange: (x?: any) => void;

    public onTouched: (x?: any) => void;

    public id: string;

    public _value: any = '';

    @Input() disabled: boolean;

    @Input() label = '';

    @Input() placeholder: string = this.label;

    @Input() type: 'text' | 'email' | 'password' | 'number' = 'text';

    @Input() validation = true;

    @Output('change') changeOutput = new EventEmitter<any>();

    @ViewChild('input', { static: true }) input;

    constructor(
        public dialog: MatDialog,
        @Self() @Optional() private ngControl: NgControl,
    ) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        this.id = uuid.v4();
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(GeoidAddressModalComponent);

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.writeValue(result);
            }
        });
    }

    get formattedAddress(): string {
        if (!this._value) {
            return '';
        }
        return `${this._value.unit ? '#' : ''}${this._value.unit} ${this._value.number} ${this._value.street}, ${this._value.city}, ${this._value.province}, ${this._value.postCode}`;
    }
    get value(): any {
        return this._value;
    }

    set value(v) {
        this._value = v;
        if (this.onChange) {
            this.changeOutput.emit(v);
            this.onChange(v);
            this.onTouched();
        }
    }

    change(v): void {
        this._value = v;
    }

    writeValue(value: any): void {
        this.value = value;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // Store the provided function as an internal method.
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        // Store the provided function as an internal method.
        this.onTouched = fn;
    }
}
